import React from "react";
import { Tabs } from "antd";
import { FONT } from "constants/index";

import LoadControlListClient from "./load-control-list-client";

const LoadControlClient = () => {
  const items = [
    {
      label: `Método Unique`,
      key: "unique",
      children: <LoadControlListClient isBoot={false} />,
    },
    {
      label: `Iniciação`,
      key: "boot",
      children: <LoadControlListClient isBoot={true} />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      centered
      size="large"
      style={{ fontFamily: FONT }}
      items={items}
    />
  );
};
export default LoadControlClient;
